package com.islamicmedia.shared.data.api

import kotlinx.coroutines.flow.Flow

data class SseEvent(
    val event: String,
    val data: String
)

/**
 * Platform-specific SSE client that streams events in real-time.
 * Each platform implements this using its native HTTP streaming capabilities.
 */
expect fun createSseFlow(
    url: String,
    body: String,
    authToken: String? = null,
    extraHeaders: Map<String, String> = emptyMap()
): Flow<SseEvent>

/**
 * Utility: parse raw SSE text into events (used by some platform implementations).
 */
fun parseSseLines(lines: List<String>): List<SseEvent> {
    val events = mutableListOf<SseEvent>()
    var currentEvent = ""
    var currentData = ""

    for (line in lines) {
        when {
            line.startsWith("event: ") -> {
                currentEvent = line.removePrefix("event: ").trim()
            }
            line.startsWith("data: ") -> {
                currentData = line.removePrefix("data: ").trim()
            }
            line.isBlank() -> {
                if (currentEvent.isNotEmpty()) {
                    events.add(SseEvent(currentEvent, currentData))
                    currentEvent = ""
                    currentData = ""
                }
            }
        }
    }
    if (currentEvent.isNotEmpty()) {
        events.add(SseEvent(currentEvent, currentData))
    }
    return events
}
